import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function NewsIconWrapper({ children, ...rest }) {
  return (
    <SvgIcon {...rest} viewBox="0 0 32 32">
      {children}
    </SvgIcon>
  );
}
